export interface AsyncIteratorProto extends AsyncDisposable {
  [Symbol.asyncIterator](): this;
}

// HACK: Extract AsyncIterator prototype from async generator function until its implemented in JS
// @see https://github.com/tc39/proposal-async-iterator-helpers
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const AsyncIteratorProto: AsyncIteratorProto = Object.getPrototypeOf(
  Object.getPrototypeOf(
    Object.getPrototypeOf(
      (async function* () {
        // Noop
      })(),
    ),
  ),
);

export interface AsyncIteratorCtor {
  new (): AsyncIteratorProto;
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const AsyncIteratorCtor: AsyncIteratorCtor =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
  (globalThis as any).AsyncIterator ??
  class AsyncIterator {
    static {
      Object.setPrototypeOf(this.prototype, AsyncIteratorProto);
    }
  };
